import $ from 'jquery';
import mediator from './mediator';

var adjustFloatingCard = function adjustFloatingCard(sizeAttr) {
  var isLargeScreen = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  $('.floating-card-image').each(function (i, el) {
    var floatingCardImage = $(el);
    floatingCardImage.css('background-image', "url(".concat(floatingCardImage.attr(sizeAttr), ")"));
  });
  $('.floating-card-container').each(function (i, el) {
    var floatingCardContainer = $(el);
    var floatingBox;

    if (floatingCardContainer.hasClass('gradient-bg') && !isLargeScreen) {
      floatingBox = "calc(".concat(floatingCardContainer.find('.floating-card-box').outerHeight(true), "px - 128px)"); // 215px gradient height, 1rem top pos, 72px mb
    } else {
      floatingBox = isLargeScreen ? "calc(".concat(floatingCardContainer.find('.floating-card-box').outerHeight(true), "px - 72px)") : '72px';
    }

    floatingCardContainer.css('padding-bottom', floatingBox);
  });
};

var configureFloatingCardImg = function configureFloatingCardImg() {
  var screenSize = window.cigna.screen.breakpoint;

  switch (screenSize) {
    case 'xs':
      adjustFloatingCard('data-xs-bg');
      break;

    case 'sm':
      adjustFloatingCard('data-sm-bg');
      break;

    case 'md':
      adjustFloatingCard('data-md-bg', true);
      break;

    case 'lg':
    case 'xl':
      adjustFloatingCard('data-lg-bg', true);
      break;

    default:
      break;
  }
};

export default (function () {
  $(document).ready(configureFloatingCardImg);
  mediator.on('window:throttledResize', configureFloatingCardImg); // In case there are expanding components like an accordion we will need to adjust margin bottom

  $('.floating-card-body').on('click', function (e) {
    e.stopPropagation();
    var findCardHeight = setInterval(configureFloatingCardImg, 10);
    setTimeout(function () {
      clearInterval(findCardHeight);
    }, 1000);
  });
});